/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Realtime_TitleInputs */

const fr_help_realtime_title = /** @type {(inputs: Help_Realtime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Disponibilité du temps réel`)
};

const en_help_realtime_title = /** @type {(inputs: Help_Realtime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Real-time availability`)
};

/**
* | output |
* | --- |
* | "3. Real-time availability" |
*
* @param {Help_Realtime_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_realtime_title = /** @type {((inputs?: Help_Realtime_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Realtime_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_realtime_title(inputs)
	return en_help_realtime_title(inputs)
});